export default "assets/images/background-e30c677d.svg";